import "./styles.css";
import { App } from "./app";

const root = document.getElementById("app");
if (root) {
  // Brief splash while we resolve the session, so we never flash the login
  // screen for an already-authenticated user.
  root.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#F4F7FA;">
      <div style="display:flex;flex-direction:column;align-items:center;gap:14px;">
        <img src="/assets/G-Shield-Blue.svg" alt="" style="height:40px;opacity:.9;">
        <div style="display:flex;gap:5px;">
          <span style="width:7px;height:7px;border-radius:999px;background:#0041ED;animation:hiveBlink 1s infinite;"></span>
          <span style="width:7px;height:7px;border-radius:999px;background:#0041ED;animation:hiveBlink 1s infinite .2s;"></span>
          <span style="width:7px;height:7px;border-radius:999px;background:#0041ED;animation:hiveBlink 1s infinite .4s;"></span>
        </div>
      </div>
    </div>`;
  const app = new App(root);
  void app.start();
}
